import { phoneRegex } from '@duke-hq/shared-constants/regexPatterns';

export const isPhoneNumber = (value: string) => phoneRegex.test(value);
